enum CardTypes {
  DEFAULT = 'default',
  INACTIVE_FEATURE = 'inactiveFeature',
  DESIGN = 'design',
  RESET = 'reset',
  SHARE = 'share',
}

interface CardCopyType {
  cardType: CardTypes;
  title: string;
  body?: string | undefined;
  feature: string;
}

const cardCopy = {
  DEFAULT: {
    cardType: CardTypes.DEFAULT,
    title: '',
    body: '',
    feature: '',
  },
  INACTIVE_WINDOW: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.inactiveWindow.title',
    body: 'menu.inactiveWindow.body',
    feature: 'windows',
  },
  DOOR: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.inactiveDoor.title',
    body: 'menu.inactiveDoor.body',
    feature: 'doors',
  },
  ACCENT: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.accent.title',
    body: 'menu.accent.body',
    feature: 'accents',
  },
  VERSION: {
    cardType: CardTypes.INACTIVE_FEATURE,
    title: 'menu.version.title',
    body: 'menu.version.body',
    feature: 'versions',
  },
  RESET: {
    cardType: CardTypes.RESET,
    title: 'menu.reset.title',
    body: 'menu.reset.body',
    feature: 'reset',
  },
  TRIM: {
    cardType: CardTypes.DESIGN,
    title: 'menu.trim.title',
    feature: 'trim',
  },
  WALL: {
    cardType: CardTypes.DESIGN,
    title: 'menu.wall.title',
    feature: 'walls',
  },
  ROOF: {
    cardType: CardTypes.DESIGN,
    title: 'menu.roof.title',
    feature: 'roof',
  },
  WINDOW: {
    cardType: CardTypes.DESIGN,
    title: 'menu.window.title',
    feature: 'windows',
  },
  SHARE: {
    cardType: CardTypes.SHARE,
    title: 'menu.share.title',
    feature: 'share',
  },
};

export { cardCopy, CardTypes, CardCopyType };
